import React, { Component } from "react";
import { connect } from "react-redux";
import PDF from "react-pdf-js";
import { hidePdfFile } from "../../../actions/pdfActions";
import store from "../../../store";

class PdfCaroussel extends Component {
	constructor(props) {
		super(props);

		this.state = {
			file: false,
			page: 1,
			rendered: true
		};
		this.handleNext = this.handleNext.bind(this);
		this.handlePrevious = this.handlePrevious.bind(this);
		this.onPageComplete = this.onPageComplete.bind(this);
		this.onDocumentComplete = this.onDocumentComplete.bind(this);
		this.handleWheel = this.handleWheel.bind(this);
		this.removeVisibilityPopup = this.removeVisibilityPopup.bind(this);
	}
	handleNext() {
		if (this.state.page !== this.state.pages)
			this.setState({ page: this.state.page + 1 });
	}
	handlePrevious() {
		if (this.state.page !== 1) this.setState({ page: this.state.page - 1 });
	}
	onPageComplete(page) {
		this.setState({ page });
	}
	onDocumentComplete(pages) {
		this.setState({ page: 1, pages });
	}
	handleWheel(event) {
		if (event.deltaY < 0 && this.state.page !== 1) {
			this.setState({ page: this.state.page - 1 });
			// User should not scroll page when changing page
			event.preventDefault();
		} else if (event.deltaY > 0 && this.state.page !== this.state.pages) {
			this.setState({ page: this.state.page + 1 });
			// User should not scroll page when changing page
			event.preventDefault();
		}
	}
	removeVisibilityPopup() {
		store.dispatch(hidePdfFile());
	}
	render() {
		const pdfCanvasParent = document.getElementsByClassName(
			"pdfCanvasParent"
		);
		// Get width and height of pdf canvas
		let width = 400;
		let height = 550;
		if (
			pdfCanvasParent &&
			pdfCanvasParent[0] &&
			pdfCanvasParent[0].children &&
			pdfCanvasParent[0].children[1] &&
			pdfCanvasParent[0].children[1].style.width
		) {
			width = parseInt(pdfCanvasParent[0].children[1].style.width, 10);
			height = parseInt(pdfCanvasParent[0].children[1].style.height, 10);
		}
		width += 20;
		height += 20;
		let visibility = "visible";
		if (!this.props.file) {
			return null;
		}

		let leftIndex = 0;
		if (this.props.orientation === "left") {
			leftIndex = this.props.positionX - width;
		} else {
			leftIndex = this.props.positionX + 20;
		}
		let topIndex = this.props.positionY - 84 - 50; //84 headerHeight, 50 just to scale better

		let popupStyle = {
			top: topIndex,
			left: leftIndex,
			visibility: visibility,
			zIndex: 4,
			position: "absolute",
			padding: 10,
			marginTop: -10
		};

		const headerStyle = {
			backgroundColor: "#ddddf1",
			color: "grey",
			textAlign: "center"
		};

		return (
			<div
				style={{ ...popupStyle, width: width, height: height }}
				onMouseLeave={this.removeVisibilityPopup}
				onWheel={e => this.handleWheel(e)}
				className="pdfCanvasParent"
			>
				<div style={headerStyle}>
					{this.state.page + "/" + this.state.pages}
				</div>

				<PDF
					onPageRender={null}
					page={this.state.page}
					scale={0.6}
					file={this.props.file}
					documentInitParameters={{}}
					onPageComplete={this.onPageComplete}
					onDocumentComplete={this.onDocumentComplete}
				/>
			</div>
		);
	}
}

const mapStateToProps = function(store) {
	return {
		file: store.pdfState.file,
		positionX: store.pdfState.positionX,
		positionY: store.pdfState.positionY,
		orientation: store.pdfState.orientation
	};
};

export default connect(mapStateToProps)(PdfCaroussel);



// WEBPACK FOOTER //
// ./src/components/views/utils/PdfCaroussel.js